import administration, { AdministrationState } from 'app/modules/administration/administration.reducer';
import order from 'app/modules/benefit/benefit-service/store/order-reducer';
import { OrderState } from 'app/modules/benefit/benefit-service/store/order-state';
import claim from 'app/modules/claim/service/store/claim-reducer';
import { ClaimState } from 'app/modules/claim/service/store/claim-state';
import cms from 'app/modules/cms/service/store/cms-reducer';
import gtm from 'app/modules/gtm/service/store/gtm.reducer';
import { GtmState } from 'app/modules/gtm/service/store/gtm.state';
import stepEngine from 'app/modules/step-engine/service/store/step-engine-reducer';
import { StepEngineState } from 'app/modules/step-engine/service/store/step-engine-state';
import { loadingBarReducer as loadingBar } from 'react-redux-loading-bar';
import { combineReducers } from 'redux';
import { CmsState } from './../../modules/cms/service/store/cms-state';
import appManagement from './app-management';
import applicationProfile, { ApplicationProfileState } from './application-profile';
import authentication, { AuthenticationState } from './authentication';
import kubrickManagement from './kubrick-management';
import locale, { LocaleState } from './locale';
import userManagement, { UserManagementState } from './user-management';

/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

export interface IRootState {
  readonly authentication: AuthenticationState;
  readonly locale: LocaleState;
  readonly applicationProfile: ApplicationProfileState;
  readonly administration: AdministrationState;
  readonly userManagement: UserManagementState;
  /* jhipster-needle-add-reducer-type - JHipster will add reducer type here */
  readonly loadingBar;

  readonly appManagement;
  readonly stepEngine: StepEngineState;
  readonly kubrickManagement;
  readonly cms: CmsState;
  readonly gtm: GtmState;
  readonly claim: ClaimState;
  readonly order: OrderState;
}

const rootReducer = combineReducers<IRootState>({
  authentication,
  locale,
  applicationProfile,
  administration,
  userManagement,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
  loadingBar,
  stepEngine,
  kubrickManagement,
  appManagement,
  cms,
  gtm,
  claim,
  order,
});

export default rootReducer;
